import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-half-image-card',
  templateUrl: './half-image-card.component.html',
  styleUrls: ['./half-image-card.component.scss']
})
export class HalfImageCardComponent implements OnInit {

  @Input() cardDetail?: any

  constructor() { }

  ngOnInit() {
  }

}
